import React, { useEffect } from 'react';
import './notFound.scss'; 

const NotFound = () => {
  useEffect(() => {
    console.log('404 page displayed in standard React app.');
  }, []);

  return (
    <div className="not-found-wrapper">
      <h1 className="not-found-heading">404</h1>
      <p>The page you are looking for does not exist.</p>
      <div className="not-found-navigation">
        <a href="/" className="homepage-link">Go to Homepage</a>
        <a href="/contact" className="dashboard-link">Contact Us</a>
      </div>
    </div>
  );
};

export default NotFound;
